
<app-component-selector 
    [campusId]="this.campus.campusId" 
    [editionId]="this.editionId"
    [webResourceId]="this.webResourceId">
</app-component-selector>
